export enum AssetTimeseriesColumns {
    assetClassID = "asset_class_id",
    assetClassName = "asset_class_name",
    assetID = "asset_id",
    assetTicker = "asset_ticker",
    date = "date",
    hidden = "hidden",
    isInvestable = "is_investable",
    issuerID = "issuer_id",
    issuerName = "issuer_name",
    measureID = "measure_id",
    measureSlug = "measure_slug",
    peggedAssetID = "pegged_asset_id",
    tokenCount = "token_count",
    tokenizationTypeIDs = "tokenization_type_ids",
    circulatingAssetValueDollar = "circulating_asset_value_dollar",
}

export enum AssetTimeseriesGroupBy {
    asset = "asset",
    assetTicker = "asset_ticker",
    assetClass = "asset_class",
    issuer = "issuer",
    jurisdictionCountry = "jurisdiction_country",
    measure = "measure",
    peggedAsset = "pegged_asset",
    manager = "manager",
    realEstateCountry = "real_estate_country",
}

export type TimeSeriesPoint = [string, number];

export interface TimeSeriesGroup {
    id: number;
    type: string;
    name: string;
    slug: string;
    color: string | null;
    // ENHANCEMENT - add icon_url to the API response?
    // icon_url?: string | null;
}

export enum TimeSeriesUnits {
    token = "token",
    dollar = "dollar",
    dollars = "Dollars", // TODO - remove either `dollar` or `Dollars`
    percent = "percent",
    year = "year",
    address = "address",
}

export interface TimeSeriesMeasure {
    id: number;
    slug: string;
    name: string;
    unit: TimeSeriesUnits;
}

export interface TimeSeriesItem {
    measure: TimeSeriesMeasure;
    group: TimeSeriesGroup;
    points: TimeSeriesPoint[];
    // points: { [key: string]: number };
}

export interface AggregateItem {
    value: number;
    date: string;
    item_count: number;
    measure: TimeSeriesMeasure;
    group: TimeSeriesGroup;
}

export enum ChartTypes {
    area = "area",
    line = "line",
    column = "column",
}

/**
 * Removes the last data point from each TimeSeriesItem if it represents the current incomplete week
 * @param item TimeSeriesItem object to process
 * @returns The TimeSeriesItem with incomplete week data point removed if applicable
 */
// export function removeIncompleteWeek(item: TimeSeriesItem): TimeSeriesItem {
//     const lastPoint = item.points[item.points.length - 1];
//     if (!lastPoint) return item;

//     const lastPointDate = new Date(lastPoint[0]);
//     const today = new Date();

//     // Calculate the start of the current week in UTC (assuming week starts on Sunday)
//     const startOfCurrentWeek = new Date(
//         Date.UTC(
//             today.getUTCFullYear(),
//             today.getUTCMonth(),
//             today.getUTCDate(),
//         ),
//     );
//     startOfCurrentWeek.setUTCDate(today.getUTCDate() - today.getUTCDay());

//     // Check if last point is in the current week in UTC
//     const isCurrentWeek =
//         lastPointDate >= startOfCurrentWeek && lastPointDate <= today;

//     if (isCurrentWeek) {
//         // Return a copy of item with last point removed
//         return {
//             ...item,
//             points: item.points.slice(0, -1),
//         };
//     }

//     return item;
// }
